import { render, staticRenderFns } from "./DocumentTypeEdit.vue?vue&type=template&id=82101690"
import script from "./DocumentTypeEdit.vue?vue&type=script&lang=js"
export * from "./DocumentTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports